import { useNavigate } from 'react-router-dom';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { ImageColumn } from '../../components/DataTable/ImageColumn';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { Gallery } from '../../interfaces/Gallery/Gallery';
import { Pagination } from '../../interfaces/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';

const columns: TableColumn<Gallery>[] = [
  {
    id: 'id',
    name: 'ID',
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'link-url',
    name: 'Link',
    accessor: (row) => <TextColumn value={row.linkUrl} />,
  },
  {
    id: 'image',
    name: 'Resim',
    accessor: (row) => <ImageColumn url={row.image} />,
    align: 'center',
  },
  {
    id: 'created-at',
    name: 'Oluşturulma Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'updated-at',
    name: 'Düzenlenme Tarihi',
    accessor: (row) => <DateColumn value={row.updatedAt} />,
  },
];

type GalleriesTableProps = {
  galleries: Gallery[];
  totalCount: number;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
};

export const GalleriesTable = (props: GalleriesTableProps) => {
  const navigate = useNavigate();

  return (
    <DataTable
      columns={columns}
      totalCount={props.totalCount}
      rows={props.galleries}
      limit={props.pagination.pageSize}
      setLimit={(newLimit) =>
        props.onPagination({ page: 0, pageSize: newLimit })
      }
      page={props.pagination.page}
      setPage={(newPage) =>
        props.onPagination({ ...props.pagination, page: newPage })
      }
      onClick={(gallery) => navigate(`/visual/galleries/${gallery.id}`)}
    />
  );
};
